const Templates = [
    {
        text: 'Text',
        title: 'Insert a text field control',
        field: 'TextControl',
        value: {
            "id": "<text-control-id>",
            "type": "text",
            "label": "<text-control-label>",
            "fullWidth": true,
            "jsonName": "<text-json-name>",
            "required": false,
            "gridSize": {
                "xs": 12,
                "sm": 12,
                "md": 6,
                "lg": 6,
                "xl": 6
            }
        }
    },
    {
        text: 'HTML',
        title: 'Insert an HTML control',
        field: 'HTML Control',
        value: {
            "id": "<html-control-id>",
            "type": "html",
            "skipSerialization": true,
            "gridSize": {
                "xs": 12
            },
            "label": "<div></div>"
        }
    },
    {
        text: 'Select',
        title: 'Insert a select field control',
        field: 'SelectControl',
        value: {
            "id": "<select-control-id>",
            "type": "select",
            "label": "<select-control-label>",
            "jsonName": "<select-json-name>",
            "fullWidth": true,
            "multiSelect": false,
            "required": false,
            "gridSize": {
                "xs": 12
            },
            "subGridSize": {
                "xs": 12,
                "sm": 12,
                "md": 6,
                "lg": 6,
                "xl": 6
            },
            "selectOptions": [
                "<option-1>",
                "<option-2>",
                "<option-3>",
                "<option-4>"
            ]
        }
    },
    {
        text: 'Date',
        title: 'Insert a date control',
        field: 'DateControl',
        value: {
            "id": "<date-control-id>",
            "type": "date",
            "label": "<date-control-label>",
            "fullWidth": true,
            "jsonName": "<date-json-name>",
            "required": true,
            "maxValue": "today",
            "gridSize": {
                "xs": 12,
                "sm": 12,
                "md": 12,
                "lg": 12,
                "xl": 12
            }
        }
    },
    {
        text: 'Phone',
        title: 'Insert a phone control',
        field: 'PhoneControl',
        value: {
            "id": "<phone-control-id>",
            "type": "phone",
            "label": "<phone-control-label>",
            "jsonName": "<phone-json-name>",
            "fullWidth": true,
            "required": true,
            "gridSize": {
                "xs": 12,
                "sm": 6,
                "md": 6,
                "lg": 6,
                "xl": 6
            }
        },
    },
    {
        text: 'Radio',
        title: 'Insert a radio control',
        field: 'RadioControl',
        value:
        {
            "type": "radio",
            "id": "<radio-control-id>",
            "jsonName": "<radio-json-name>",
            "label": "<radio-control-label>",
            "required": true,
            "fullWidth": true,
            "rows": 1,
            "gridSize": {
                "xs": 12,
                "sm": 6,
                "md": 6,
                "lg": 6,
                "xl": 6
            },
            "selectOptions": [
                "Option 1",
                "Option 2",
                "Option 3"
            ]
        }
    },
    {
        text: 'Checkbox',
        title: 'Insert a checkbox control',
        field: 'CheckboxControl',
        value:
        {
            "id": "<checkbox-control-id>",
            "type": "checkbox",
            "label": "<checkbox-control-label>",
            "fullWidth": true,
            "multiSelect": true,
            "gridSize": {
                "xs": 12
            },
            "subGridSize": {
                "xs": 12,
                "sm": 12,
                "md": 6,
                "lg": 4,
                "xl": 4
            },
            "selectPropertyOptions": [
                {
                    "label": "Option 1",
                    "jsonName": "option1"
                },
                {
                    "label": "Option 2",
                    "jsonName": "option2"
                },
                {
                    "label": "Option 3",
                    "jsonName": "option3"
                },
                {
                    "label": "Option 4",
                    "jsonName": "option4"
                }
            ]
        }
    },
    {
        text: 'Upload',
        title: 'Insert an upload control',
        field: 'UploadControl',
        value: {
            "id": "<upload-control-id>",
            "type": "upload",
            "label": "<upload-control-label>",
            "jsonName": "<upload-json-name>",
            "fullWidth": true,
            "fileUploadOptions": {
                "multipleFiles": false,
                "fileAccept": "image/*"
            },
            "gridSize": {
                "xs": 12
            }
        }
    },
    {
        text: 'Masked',
        title: 'Insert an masked input control',
        field: 'MaskedControl',
        value: {
            "id": "<masked-control-id>",
            "type": "masked",
            "label": "<masked-control-label>",
            "jsonName": "<masked-json-name>",
            "fullWidth": true,
            "mask": "999-99-9999",
            "gridSize": {
                "xs": 12,
                "sm": 6,
                "md": 6,
                "lg": 6,
                "xl": 6
            }
        }
    },
    {
        text: 'Cancel',
        title: 'Insert a cancel button',
        field: 'CancelButtonControl',
        value: {
            "id": "cancel",
            "type": "cancel",
            "label": "Cancel",
            "fullWidth": true,
            "skipSerialization": true,
            "gridSize": {
                "xs": 1
            }
        }
    },
    {
        text: 'Submit',
        title: 'Insert a submit button',
        field: 'SubmitButtonControl',
        value: {
            "id": "submit",
            "type": "submit",
            "label": "Submit",
            "fullWidth": true,
            "skipSerialization": true,
            "gridSize": {
                "lg": 11,
                "sm": 10,
                "xs": 9
            }
        }
    },
];

export default Templates;